<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>用户号</label>
			<a-input style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="customerNum"/>
			<label>用户名</label>
			<a-input style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="customerName"/>
			<a-button size="small"   icon="search" @click="doQuery">查询</a-button>
			<a-checkbox  @change="lihuCheck" style="font-size: 0.65rem;margin-left:1rem;" v-if="wcId == 4">只看立户表</a-checkbox>
			<a-button style="margin:0 0.5rem;" v-if="wcId == 4" @click="exportCustomerList" :disabled="customerList.length==0">导出Excel</a-button>
			<a-button size="small"   icon="plus" @click="showAddFlag = true" style="margin: 0 0.75rem;">添加</a-button>
			<a-button size="small"   icon="file-add" @click="showBatchAddFlag = true">批量添加</a-button>
			<a-button size="small" style="margin:0 0.5rem;"   icon="home" @click="showOutFlag = true" v-if="check4Wh">修改室内外</a-button>
		</div>
		<vxe-table  align="center" :data="customerList"  border max-height="600"  :cell-style="cellClassName" ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column title="用户号" field="customerNum" width="80"></vxe-table-column>
			<vxe-table-column title="用户名" field="customerName"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="给水号" field="apId" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="手机" field="customerMobile"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="身份证" field="nationalId"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="地址" field="customerAddr"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="用水类型" field="houseKindId"  :formatter="getHouseKindType"></vxe-table-column>
			<vxe-table-column title="户数" field="peoplecnt" ></vxe-table-column>
			<vxe-table-column title="余额" field="customerBalance" ></vxe-table-column>
			<vxe-table-column title="预付费" field="prePaySign"  :formatter="getPrepaySign"></vxe-table-column>
			<vxe-table-column title="余额阀值" field="warnThre" ></vxe-table-column>
			<vxe-table-column title="提醒方式" field="warnStyle" :formatter="getWarnStyle"></vxe-table-column>
			<vxe-table-column title="提醒开关" field="warnSwitch" :formatter="getWarnSwitch"></vxe-table-column>
			<vxe-table-column title="操作" field="pId" width="240">
				<template #default="{ row }">
					<a-button size="small" type="link" @click="viewContent(row)">查看表具</a-button>
					<a-button size="small" type="link" @click="editContent(row)">修改</a-button>
					<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(row)">
						<a-button size="small"  type="link">删除</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="showAdjustMeter(row)">调整表具</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>
		<vxe-modal ref="mModal" v-model="showMeterListFlag" title="表具信息" width="auto" height="450"
								resize destroy-on-close :mask="false" :lock-view="false" :show-zoom="true" :position="{top:350}">
			<ShowMeterList :theObj = "theObj" @editMeter="showEditMeter" @deleteMeter="showDeleteMeter" 
									@showChangeMeter="showTheChangeMeter" @changeMeterHistory="showChangeMeterHistory"/>
		</vxe-modal>
		<a-drawer title="修改用户" :visible="editFlag"  width="640" @close="onEditClose()" :destroyOnClose='true' :maskClosable="false">
			<EditCustomer :theObj="theObj" :theNeighbor="theNeighbor" @cancelEdit="onEditClose" @refreshList="doQuery"/>
		</a-drawer>
		<a-modal title="调整表具" :visible="showAdjustFlag" @ok="adjustMeter" @cancel="showAdjustFlag = false" 
					cancel-text="取消" ok-text="提交" :confirm-loading="adjustSubmitFlag" :dialog-style="{ top: '20px' }">
			<a-form-model ref="adjustForm"  :model="adjustForm" :rules="adjustFormRules"  :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" >
				<a-form-model-item label="集中器地址" prop="gprsAddr">
					<a-input  v-model="adjustForm.gprsAddr"/>
				</a-form-model-item>
				<a-form-model-item label="采集器地址" prop="collectorAddr">
					<a-input  v-model="adjustForm.collectorAddr"/>
				</a-form-model-item>
				<a-form-model-item label="表地址" prop="meterAddr">
					<a-input  v-model="adjustForm.meterAddr"/>
				</a-form-model-item>
				<span style="color: #FF0000; font-size: 0.75rem;">将此表扣过的水费，加回给原来的用户，在新用户中扣掉，并将此表对应到新用户下.</span>
			</a-form-model>
		</a-modal>
		<a-drawer title="修改表信息" :visible="meterEditFlag"  width="720" @close="meterEditFlag = false" :destroyOnClose='true' :maskClosable="false">
			<EditMeter :theMeter="theMeter" @cancelEdit="meterEditFlag = false"/>
		</a-drawer>
		<a-drawer title="换表历史" :visible="changeHistoryFlag"  width="1000" @close="changeHistoryFlag = false" :destroyOnClose="true">
			<MeterChangeHistory :meterId="theMeter.PID"/>
		</a-drawer >
		<a-drawer title="添加用户" :visible="showAddFlag"  width="900" @close="onAddCose" :destroyOnClose="true"  :maskClosable="false">
			<AddCustomerMeter @onClose="onAddCose" />
		</a-drawer>
		<a-drawer title="批量添加用户"  :visible="showBatchAddFlag" width="520" :closable="true" @close="showBatchAddFlag = false" :destroyOnClose="true"  :maskClosable="false">
			<BatchAddCustomerMeter  @uploadingChange="uploadingChange"/>
		</a-drawer>
		<a-modal title="换表"  :visible="showChangeFlag"  @ok="changeMeter" @cancel="closeChangeMeter" :dialog-style="{ top: '20px' }" 
					cancel-text="取消" ok-text="提交" :confirm-loading="changeSubmitFlag" :destroyOnClose = "true">
			<a-form-model ref="changeForm"  :model="changeForm" :rules="changeFormRules"  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
				<a-form-model-item label="新表地址" prop="newMeterAddr">
					<a-input  v-model="changeForm.newMeterAddr" style="width: 19rem;"/>
				</a-form-model-item>
				<a-form-model-item label="换表底数" prop="endRead">
					<a-input-number  v-model="changeForm.endRead" :min="0" :precision="0" style="width: 19rem;"/>
				</a-form-model-item>
				<a-form-model-item label="新钢印号" prop="newSteelNum">
					<a-input  v-model="changeForm.newSteelNum" style="width: 19rem;"/>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	   <a-drawer title="生产信息" :visible="TraceInfoFlag" width="1500" @close="TraceInfoFlag = false"> 
			<TraceInfo :sn="sn"/>
	   </a-drawer>
	   <vxe-modal ref="nModal" v-model="showOutFlag" title="修改表具室内外信息" width="420" height="auto"
	   						 destroy-on-close :mask="false" :lock-view="false" show-footer>
			<a-form-model ref="updateOutForm"  :model="updateOutForm"  :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" >
				<a-form-model-item label="类型" prop="outType">
					<a-select  style="font-size: 0.6875rem;" v-model="updateOutForm.outType">
						<a-select-option v-for="(item,index) in outTypeList" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="序列号" prop="ids">
					<a-textarea placeholder="多个号之间使用英文逗号分割" :rows="6" v-model = "updateOutForm.ids"/>
				</a-form-model-item>
			</a-form-model>
			<template #footer>
				<div class="drawerFooter">
				    <a-button size="small" icon="close" @click="showOutFlag = false" style="margin-right: 0.625rem;">取 消</a-button>
				    <a-button size="small"  icon="check" type="primary" @click="submitUpdateOutType" :loading="submiting">提 交</a-button>
				</div>
			</template>
		</vxe-modal>
	</div>
</template>

<script>
	import EditCustomer from '../components/EditCustomer.vue'
	import EditMeter from '../components/EditMeter.vue'
	import MeterChangeHistory from '../components/MeterChangeHistory.vue'
	import AddCustomerMeter from '../components/AddCustomerMeter.vue'
	import BatchAddCustomerMeter from '../components/BatchAddCustomerMeter.vue'
	import TraceInfo from '../components/TraceInfo.vue'
	import ShowMeterList from  '../components/ShowMeterList.vue'
	export default{
		components:{
			EditCustomer,
			EditMeter,
			MeterChangeHistory,
			AddCustomerMeter,
			BatchAddCustomerMeter,
			TraceInfo,
			ShowMeterList,
		},
		data(){
			return{
				sn:null,
				showMeterListFlag:false,
				TraceInfoFlag:false,
				neighborList:[],
				customerList:[],
				sn:null,
				expandedRowKeys:[],
				theNeighbor:undefined,
				customerNum:null,
				customerName:null,
				loading:false,
				editFlag:false,
				showAdjustFlag:false,
				adjustSubmitFlag:false,
				meterEditFlag:false,
				showChangeFlag:false,
				changeSubmitFlag:false,
				changeHistoryFlag:false,
				showAddFlag:false,
				showBatchAddFlag:false,
				batchUploading:false,
				TraceInfoFlag:false,
				theObj:null,
				theMeter:{},
				adjustForm:{},
				changeForm:{
					endRead:null,
					newMeterAddr:null,
				},
				adjustFormRules:{
					gprsAddr:[{required:true,message:'请输入集中器地址',trigger: 'blur'},],
					collectorAddr:[{required:true,message:'请输入采集器地址',trigger: 'blur'},],
					meterAddr:[{required:true,message:'请输入表地址',trigger: 'blur'},],
				},
				changeFormRules:{
					newMeterAddr:[{required:true,message:'请输入新表地址',trigger: 'blur'},],
					endRead:[{required:true,message:'请输入换表底数',trigger: 'blur'},]
				},
				wcId:null,
				lihu:'',
				showOutFlag:false,
				updateOutForm:{
					outType:'0',
					ids:null,
				},
				submiting:false,
			}
		},
		methods:{
			submitUpdateOutType(){
				this.submiting = true;
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_OUTTYPE_URL);
				this.Api.fetchPostWithForm(url,this.updateOutForm).then((data)=>{
					this.submiting = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('修改成功');
						this.showOutFlag = false;
						this.updateOutForm.ids = null;
						this.updateOutForm.outType = '0';
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submiting = false;
				});
			},
			exportCustomerList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_EXPORT_URL);
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label,lihu:this.lihu};
				this.Api.fetchPostFile(url,param).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = this.Config.formatDateShortly(new Date)+ this.theNeighbor.label+'.xls'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
			lihuCheck:function(e){
				this.lihu = e.target.checked?'1':'0';
				this.doQuery();
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			viewContent:function(item){
				this.theObj = this.Config.deepClone(item);
				this.showMeterListFlag = true;
			},
			//查看水表生产信息
			showProduceInfo:function(item){
				this.TraceInfoFlag = true;
			},
				//关闭水表生产信息
			closeProduceInfo:function(item){
				this.TraceInfoFlag = false;
			},
			uploadingChange:function(param){
				let flag =  param[0];
				this.batchUploading = flag;
			},
			onAddCose:function(){
				this.showAddFlag = false;
			},
			onEditClose:function(){
					this.editFlag = false;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			cellClassName({ row, rowIndex, column }){
				if(column.property == 'customerBalance'){
					if(row.customerBalance<=0){
						 return {
							 backgroundColor: '#ffee00',
							 color: '#ff0000'
						 }
					}
				}else{
					return {
						color:'#000',
					}
				}	
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doQuery:function(){
				if(this.theNeighbor !=null && this.theNeighbor!=undefined){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_LIST_WITH_NUM_URL);
					let param = {
						neighborId:this.theNeighbor.key,
						customerNum:this.customerNum,
						customerName:this.customerName,
						lihu:this.lihu,
					};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.customerList = result;
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
						this.loading = false;
					});
				}else{
					this.$message.error('请选择小区');
				}
			},
			//删除表具
			showDeleteMeter:function(param){
				this.showMeterListFlag = false;
				this.deleteMeter(param[0]);
			},
			//修改表具
			showEditMeter:function(param){
				this.showMeterListFlag = false;
				this.editMeter(param[0]);
			},
			//换表
			showTheChangeMeter:function(param){
				this.showChangeMeter(param[0]);
			},
			showChangeMeterHistory:function(param){
				this.showMeterListFlag = false;
				this.changeMeterHistory(param[0]);
			},
			showAdjustMeter:function(item){
				this.theObj = item;
				this.showAdjustFlag = true;
			},
			adjustMeter:function(){
				this.$refs.adjustForm.validate(valid => {
					if(valid) {
						this.adjustSubmitFlag = true;
						let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_ADJUST_URL);
						this.adjustForm.customerId = this.theObj.pId;
						this.Api.fetchPostWithForm(url,this.adjustForm).then((data)=>{
							this.adjustSubmitFlag = false;
							let code = data.data.code;
							let msg = data.data.message;
							if(code == this.Api.HTTP_OK_CODE){
								this.$message.success(msg);
								this.showAdjustFlag = false;
								this.$refs.adjustForm.destroy();
							}else{
								this.$message.error(msg);
							}
						}).catch((error)=>{
							console.log(error);
							this.adjustSubmitFlag = false;
						});
					} else {
						return false;
					}
				});
			},
			editContent:function(item){
				this.theObj = this.Config.deepClone(item);
				this.editFlag = true;
			},
			deleteContent:function(item){
				let param = {theId:item.pId};
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_DELETE_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getHouseKindType({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getHouseKindList());
			},
			getPrepaySign({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getPrepaySignList());
			},
			getWarnStyle({cellValue}){
				return cellValue == 1?'短信':'邮件';
			},
			getWarnSwitch({cellValue}){
				return cellValue == 1?'开':'关';
			},
			editMeter:function(item){
				this.theMeter = this.Config.deepClone(item);
				this.meterEditFlag = true;
			},
			deleteMeter:function(item){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_DELETE_URL);
				let param = {theId:item.PID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('删除成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			changeMeter:function(){
				this.$refs.changeForm.validate(valid => {
					if(valid) {
						this.doChangeMeter();
					}else{
						return false;
					}
				});
			},
			doChangeMeter:function(){
				this.changeSubmitFlag = true;
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_CHANGE_URL);
				this.changeForm.neighborId = this.theNeighbor.key;
				this.changeForm.customerNum = this.theObj.customerNum;
				this.changeForm.louNum = this.theObj.louNum;
				this.changeForm.meterId = this.theMeter.PID;
				this.Api.fetchPostWithForm(url,this.changeForm).then((data)=>{
					this.changeSubmitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.changeForm.endRead = null;
						this.changeForm.newMeterAddr = null;
						this.$message.success('换表操作成功');
						this.showChangeFlag = false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.changeSubmitFlag = false;
					console.log(error);
				});
			},
			closeChangeMeter:function(){
				this.showChangeFlag = false;
				this.$refs.changeForm.resetFields();
			},
			showChangeMeter:function(item){
				this.theMeter = item;
				this.showChangeFlag = true;	
			},
			changeMeterHistory:function(item){
				this.theMeter = item;
				this.changeHistoryFlag = true;
			},
			//查看水表生产信息
			showProduceInfo:function(item){
	            this.TraceInfoFlag = true;
			},
			//关闭水表生产信息
			closeProduceInfo:function(item){
				this.TraceInfoFlag = false;
			},
		},
		created() {
			this.queryNeighbors();
			this.wcId = this.Config.getUserLocal().wcId;
		},
		computed: {
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
			outTypeList:function(){
				return this.Config.getOutTypeList();
			}
		},
	}
</script>

<style>
</style>
